import http from '@/http'
import TaskCardHistory from '@/store/models/TaskCardHistory'
import { serializeObjectToQueryParameter } from '@/store/helper'

const API_PATH = 'organizations/:organizationId/projects/:projectId/task_cards/:taskCardId/task_card_histories/'

const configureApiPath = ({ organizationId, projectId, taskCardId }) => {
  return API_PATH.replace(':organizationId', organizationId)
                 .replace(':projectId', projectId)
                 .replace(':taskCardId', taskCardId)
}

const defaultState = () => {
  return {
    pagination: {}
  }
}

const state = defaultState()

const getters = {
  pagination: state => state.pagination
}

const mutations = {
  pagination(state, payload) {
    state.pagination = payload
  },
  resetModule(state) {
    Object.assign(state, defaultState())
  }
}

const actions = {
  async index({ commit, rootGetters }, payload) {
    const { projectId, taskCardId } = payload
    const apiPath = configureApiPath({
      organizationId: rootGetters['auth/currentOrganization'].id,
      projectId: projectId,
      taskCardId: taskCardId
    })
    await http.get(apiPath + serializeObjectToQueryParameter(payload)).then(response => {
      commit('pagination', response.data.pagination)
      TaskCardHistory.insert({
        data: response.data.data.map((taskCard, i) => {
          if (response.data.pagination.pages === response.data.pagination.current && i + 1 === response.data.data.length) {
            return Object.assign(taskCard.attributes, {
              isFirst: true
            })
          } else {
            return taskCard.attributes
          }
        })
      })
    }).catch(error => {
      commit('setHttpError', error, { root: true })
    })
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
